/*
 *  @param { string } dayOfWeek - The day of the week to compare to e.g. Monday
 *  As a precaution also supports reduced names e.g. Mon
 *  @returns { boolean } - Returns true if the current day of the week is the same as the passed day of the week
 */
export function isSameDayOfWeek(dayOfWeek: string) {
    switch (dayOfWeek.toLowerCase()) {  
        case 'sunday':
            return new Date().getDay() === 0;
        case 'monday':
            return new Date().getDay() === 1;
        case 'tuesday':
            return new Date().getDay() === 2;
        case 'wednesday':
            return new Date().getDay() === 3;
        case 'thursday':
            return new Date().getDay() === 4;
        case 'friday':
            return new Date().getDay() === 5;
        case 'saturday':
            return new Date().getDay() === 6;
        case 'sun':
            return new Date().getDay() === 0;
        case 'mon':
            return new Date().getDay() === 1;
        case 'tue':
            return new Date().getDay() === 2;
        case 'wed':
            return new Date().getDay() === 3;
        case 'thu':
            return new Date().getDay() === 4;
        case 'fri':
            return new Date().getDay() === 5;
        case 'sat':
            return new Date().getDay() === 6;
        default:
            return false;
    }
}
